module.exports = __webpack_public_path__ + "static/media/4f27cbf7f975daa32fe7c8dec19ce2de.4f27cbf7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/4f27cbf7f975daa32fe7c8dec19ce2de.svg
// module id = 1238
// module chunks = 21